export default __webpack_public_path__ + "static/media/ground.af820eab.svg";